import { render, staticRenderFns } from "./brandMap.vue?vue&type=template&id=b8755546&scoped=true&"
import script from "./brandMap.vue?vue&type=script&lang=js&"
export * from "./brandMap.vue?vue&type=script&lang=js&"
import style0 from "./brandMap.vue?vue&type=style&index=0&id=b8755546&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8755546",
  null
  
)

export default component.exports